/* Collection pages, computers, layout "Right menu + path line" (BNJMN, 2 Nov 2026): the Filter sheet.
   The Filter icon at the right end of the path line opens #main-collection-filters from the bottom of the window, the page behind
   it washed. All groups are open; Categories come first (a copy of the open menu group, same picks as the side menu), then the
   store's filter groups, Sort last. Reset and Close sit at the foot. Esc, Close and a click on the wash shut it. Filters, sort and
   price keep working in place (ve-collection.js); this file only opens, shuts and keeps the groups open after each reload. */
(() => {
  if (window.veSideSheetReady) return;
  window.veSideSheetReady = true;
  const desktop = matchMedia('(min-width: 990px)');
  const header = () => document.querySelector('ve-header[data-ve-side], [data-ve-side]');
  const sheet = () => document.getElementById('main-collection-filters') || document.getElementById('main-search-filters');
  const isOpen = () => document.documentElement.classList.contains('ve-sheet-open');

  const wash = () => {
    let el = document.querySelector('.ve-sheet-wash');
    if (!el) {
      el = document.createElement('div');
      el.className = 've-sheet-wash';
      el.setAttribute('aria-hidden', 'true');
      (document.querySelector('.ve-page') || document.body).append(el);
    }
    return el;
  };

  // Categories: the open group of the side menu, copied (picks are handled by ve-menu-picks.js, which knows .ve-sheet-cats)
  const ensureCategories = () => {
    const root = sheet();
    const head = header();
    if (!root || !head) return;
    const container = root.querySelector('.facets-container');
    if (!container) return;
    const source = document.querySelector('.ve-side .ve-nav__sub:not([hidden])');
    const links = source ? [...source.querySelectorAll('a[data-ve-pick]')] : [];
    let column = container.querySelector('.ve-sheet-cats');
    if (!links.length) { column?.remove(); return; }
    if (!column) {
      column = document.createElement('div');
      column.className = 've-sheet-cats';
      column.innerHTML = '<div class="ve-sheet-cats__title"></div><ul class="ve-sheet-cats__list" role="list"></ul>';
      column.querySelector('.ve-sheet-cats__title').textContent = head.dataset.veCatsLabel || 'Categories';
      container.prepend(column);
    }
    const list = column.querySelector('.ve-sheet-cats__list');
    // Nothing to do when the copy already matches (the observers below would otherwise feed on their own changes)
    const key = links.map((link) => `${link.getAttribute('href')}|${link.classList.contains('is-selected')}`).join(';');
    if (column.dataset.key === key) return;
    column.dataset.key = key;
    list.replaceChildren(...links.map((link) => {
      const li = document.createElement('li');
      const copy = link.cloneNode(true);
      copy.classList.remove('ve-nav__link', 've-nav__choice', 've-motion-control', 've-motion-selected');
      // the arrival motion splits the menu's labels into letters (and keeps a hidden copy of the text for screen readers, hidden
      // only inside the header): the sheet gets the plain label
      copy.querySelectorAll('.ve-motion-text').forEach((wrapper) => {
        const spoken = wrapper.querySelector('.ve-motion-sr');
        wrapper.replaceWith(document.createTextNode(spoken ? spoken.textContent : wrapper.textContent));
      });
      li.append(copy);
      return li;
    }));
  };

  // Every group stays open and cannot be folded
  const openGroups = () => {
    sheet()?.querySelectorAll('details.ve-filter__group:not([open])').forEach((group) => group.setAttribute('open', ''));
  };
  const refresh = () => {
    if (!header() || !sheet()) return;
    ensureCategories();
    openGroups();
  };

  const setOpen = (open) => {
    if (!desktop.matches || !header() || !sheet()) return;
    wash();
    // Movement only after the first open / close, so nothing slides in while the page loads
    document.documentElement.classList.add('ve-sheet-anim');
    document.documentElement.classList.toggle('ve-sheet-open', open);
    if (open) document.documentElement.classList.remove('ve-spanel-open');
    document.querySelectorAll('[data-ve-sheet-open]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
    if (open) {
      refresh();
      sheet().setAttribute('role', 'dialog');
      sheet().setAttribute('aria-modal', 'true');
      sheet().querySelector('[data-ve-sheet-close]')?.focus({ preventScroll: true });
    } else {
      sheet().removeAttribute('role');
      sheet().removeAttribute('aria-modal');
      document.querySelector('[data-ve-sheet-open]')?.focus({ preventScroll: true });
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ve-sheet-open]')) { event.preventDefault(); setOpen(!isOpen()); return; }
    if (event.target.closest('[data-ve-sheet-close]')) { event.preventDefault(); setOpen(false); return; }
    if (isOpen() && event.target.closest('.ve-sheet-wash')) setOpen(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) setOpen(false);
  });
  // The wash covers the page, so it takes the click even though the sheet is above it
  document.addEventListener('pointerdown', (event) => {
    if (isOpen() && !event.target.closest('#main-collection-filters, #main-search-filters, [data-ve-sheet-open]')) setOpen(false);
  });
  desktop.addEventListener('change', () => { if (!desktop.matches) setOpen(false); });

  // ---------- The Search panel (BNJMN, 2 Nov 2026) ----------
  const spanel = () => document.getElementById('VeSearchPanel');
  const spOpen = () => document.documentElement.classList.contains('ve-spanel-open');
  const setPanel = (open) => {
    const el = spanel();
    if (!el || !desktop.matches) return;
    wash();
    document.documentElement.classList.add('ve-sheet-anim');
    if (open && isOpen()) setOpen(false);
    document.documentElement.classList.toggle('ve-spanel-open', open);
    document.querySelectorAll('[data-ve-spanel-open]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
    if (open) setTimeout(() => el.querySelector('[data-ve-spanel-input]')?.focus({ preventScroll: true }), 60);
    else document.querySelector('[data-ve-spanel-open]')?.focus({ preventScroll: true });
  };
  const esc = (text) => text.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const bold = (text, term) => {
    const safe = esc(text);
    const at = text.toLowerCase().indexOf(term.toLowerCase());
    if (at < 0) return safe;
    return esc(text.slice(0, at)) + '<mark>' + esc(text.slice(at, at + term.length)) + '</mark>' + esc(text.slice(at + term.length));
  };
  let spToken = 0;
  let spTimer = 0;
  const spUpdate = async () => {
    const el = spanel();
    if (!el) return;
    const input = el.querySelector('[data-ve-spanel-input]');
    const term = input.value.trim();
    const live = el.querySelector('[data-ve-spanel-live]');
    const rest = el.querySelector('[data-ve-spanel-rest]');
    el.querySelector('[data-ve-spanel-clear]').hidden = !input.value;
    if (!term) { live.hidden = true; rest.hidden = false; spToken++; return; }
    const token = ++spToken;
    try {
      const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=collection,query,product&resources[limit]=10`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.status);
      const data = (await response.json()).resources?.results || {};
      if (token !== spToken) return;
      const rows = [];
      const seen = new Set();
      const add = (html, label, href) => {
        const key = label.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        rows.push(`<li><a href="${href}">${html}</a></li>`);
      };
      (data.collections || []).forEach((c) => add(bold(c.title, term), c.title, c.url));
      (data.queries || []).forEach((q) => add((q.styled_text || esc(q.text)).replace(/<(?!\/?mark>)[^>]*>/g, ''), q.text, q.url));
      el.querySelector('[data-ve-spanel-results]').innerHTML = rows.slice(0, 6).join('');
      const count = (data.products || []).length;
      const all = el.querySelector('[data-ve-spanel-all]');
      all.href = `/search?q=${encodeURIComponent(term)}`;
      all.textContent = `${all.dataset.label}${count ? ` (${count >= 10 ? '10+' : count})` : ''}`;
      live.hidden = false;
      rest.hidden = true;
    } catch (error) {
      // Suggestions are a convenience: the form still searches on Enter
    }
  };
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-ve-spanel-input]')) return;
    clearTimeout(spTimer);
    spTimer = setTimeout(spUpdate, 150);
    spanel().querySelector('[data-ve-spanel-clear]').hidden = !event.target.value;
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ve-spanel-open]')) { event.preventDefault(); setPanel(!spOpen()); return; }
    if (event.target.closest('[data-ve-spanel-clear]')) {
      const input = spanel().querySelector('[data-ve-spanel-input]');
      input.value = '';
      input.focus();
      spUpdate();
      return;
    }
    if (spOpen() && event.target.closest('.ve-sheet-wash')) setPanel(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && spOpen()) setPanel(false);
  });
  document.addEventListener('pointerdown', (event) => {
    if (spOpen() && !event.target.closest('#VeSearchPanel, [data-ve-spanel-open]')) setPanel(false);
  });
  desktop.addEventListener('change', () => { if (!desktop.matches) setPanel(false); });

  // After every in-place reload (ve-collection.js re-renders the sheet) and when a category is picked in the menu
  const watch = () => {
    const layout = document.querySelector('.ve-collection-layout');
    if (!layout) return;
    // Only a re-render of the sheet or the groups matters; changes inside our own Categories copy are ignored
    new MutationObserver((records) => {
      if (isOpen() && records.some((r) => !r.target.closest?.('.ve-sheet-cats') && !r.target.closest?.('#ProductGridContainer'))) refresh();
    }).observe(layout, { childList: true, subtree: true });
    const side = document.querySelector('.ve-side');
    if (side) new MutationObserver(() => { if (isOpen()) ensureCategories(); }).observe(side, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  // Collections (BNJMN, 2 Nov): the menu column is as wide as its longest label (the text, plus the category indent), so that label
  // ends exactly where "Cart [n]" ends (the right padding). The picked-category marker is left out of the measure, so picking a
  // category never moves the column or the grid. Home page: not used (its menu keeps the fixed width).
  const fit = () => {
    const head = header();
    const page = document.querySelector('.ve-page');
    if (!head || !page || head.hasAttribute('data-ve-home') || !desktop.matches) return;
    let need = 0;
    head.querySelectorAll('.ve-side .ve-nav a').forEach((a) => {
      // The arrival motion splits a label into letters and adds a hidden copy for screen readers that sticks out 1px: measure the
      // visible letters only (first to last), else the text itself
      let width = 0;
      const cells = a.querySelectorAll('.ve-motion-cell');
      if (cells.length) {
        width = cells[cells.length - 1].getBoundingClientRect().right - cells[0].getBoundingClientRect().left;
      } else {
        const range = document.createRange();
        range.selectNodeContents(a);
        width = range.getBoundingClientRect().width;
      }
      if (!width) return;
      const sub = a.closest('.ve-nav__sub');
      const indent = sub ? parseFloat(getComputedStyle(sub).paddingInlineStart) || 0 : 0;
      need = Math.max(need, indent + width);
    });
    if (need > 0) page.style.setProperty('--ve-rm-fit', need.toFixed(2) + 'px');
  };
  const fitSoon = () => {
    fit();
    if (document.fonts?.ready) document.fonts.ready.then(fit);
    setTimeout(fit, 400);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitSoon);
  else fitSoon();
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit);
  document.addEventListener('shopify:section:load', fitSoon);
  // ---------- Search results (BNJMN, 2 Nov 2026): the same sheet with the search's own filters ----------
  // Every choice is a link (or the sort / price form) and the page reloads with it, so the sheet is opened again after the reload.
  const searchSheet = () => document.getElementById('main-search-filters');
  const KEEP = 'veSheetReopen';
  const keepOpen = () => { try { sessionStorage.setItem(KEEP, '1'); } catch (error) { /* private window: the sheet just stays shut */ } };
  document.addEventListener('click', (event) => {
    const root = searchSheet();
    if (!root || !root.contains(event.target)) return;
    const sort = event.target.closest('[data-ve-search-sort]');
    if (sort) {
      event.preventDefault();
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sort.dataset.veSearchSort);
      url.searchParams.delete('page');
      keepOpen();
      location.assign(url);
      return;
    }
    if (event.target.closest('a.ve-filter__value, a.ve-sheet__reset')) keepOpen();
  });
  const sendPrice = (form) => {
    const url = new URL(location.href);
    form.querySelectorAll('input[name]').forEach((input) => {
      if (input.value !== '') url.searchParams.set(input.name, input.value);
      else url.searchParams.delete(input.name);
    });
    url.searchParams.delete('page');
    keepOpen();
    location.assign(url);
  };
  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('#main-search-filters form[data-ve-price]');
    if (!form) return;
    event.preventDefault();
    sendPrice(form);
  });
  document.addEventListener('change', (event) => {
    const form = event.target.closest?.('#main-search-filters form[data-ve-price]');
    if (form) sendPrice(form);
  });
  const searchInit = () => {
    const root = searchSheet();
    if (!root) return;
    // the sort in the address is the picked one (Shopify's search does not know "New", the page script orders it)
    const picked = new URLSearchParams(location.search).get('sort_by');
    root.querySelectorAll('[data-ve-search-sort]').forEach((link) => {
      if (picked && link.dataset.veSearchSort === picked) link.setAttribute('aria-current', 'true');
    });
    let again = false;
    try { again = sessionStorage.getItem(KEEP) === '1'; sessionStorage.removeItem(KEEP); } catch (error) { again = false; }
    if (again && desktop.matches) {
      // straight open, no slide: the page has only just reloaded with the pick
      wash();
      document.documentElement.classList.add('ve-sheet-instant', 've-sheet-open');
      setTimeout(() => document.documentElement.classList.remove('ve-sheet-instant'), 120);
      document.querySelectorAll('[data-ve-sheet-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
      refresh();
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', searchInit);
  else searchInit();
})();
